import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";
import type { PropertySelectionItem as HmPropertySelectionItem } from "libs/codegen/homes-onbaording";
import type { PropertySelectionItem } from "libs/codegen/property-onboarding";

export const propertiesAtom = atom<(PropertySelectionItem | HmPropertySelectionItem)[]>([]);

export const usePropertiesState = () => useAtom(propertiesAtom);
export const usePropertiesValue = () => useAtomValue(propertiesAtom);
export const useSetProperties = () => useSetAtom(propertiesAtom);
